import React from "react";
import { NavLink, Link } from "react-router-dom";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { useGetAllCategoryListQuery } from "../../../utils/api/category/category.api";
import { FiPhoneCall } from "react-icons/fi";
import { FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";

const FrontFooter = () => {
  const { data } = useGetAllCategoryListQuery();
  const date = new Date();

  return (
    <footer className="footer-component">
      <div className="container pt-5 pb-4">
        <div className="row footer-main-content">
          {/* Colonne gauche - AMILINK et Contact */}
          <div className="col-lg-4 col-md-6 mb-4 footer-column">
            <h3 className="footer-brand-title">AMILINK</h3>
            <h4 className="footer-section-title no-underline">Contactez-nous</h4>
            <div className="footer-contact-list">
              <div className="footer-contact-item">
                <AiOutlineWhatsApp className="footer-contact-icon" />
                <div className="footer-contact-text">
                  <span className="footer-contact-label">Whats App</span>
                  <Link 
                    to="https://wa.me/8613060949102" 
                    className="footer-contact-link" 
                    target="_blank"
                  >
                    +86 130 6094 9102
                  </Link>
                </div>
              </div>
              <div className="footer-contact-item">
                <FiPhoneCall className="footer-contact-icon" />
                <div className="footer-contact-text">
                  <span className="footer-contact-label">Téléphone</span>
                  <Link 
                    to="tel:+8613060949102" 
                    className="footer-contact-link"
                  >
                    +86 130 6094 9102
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Colonne milieu - Nos catégories */}
          <div className="col-lg-4 col-md-6 mb-4 footer-column">
            <h4 className="footer-section-title">Nos catégories</h4>
            <ul className="footer-list">
              {data?.results?.slice(0, 4).map((item) => (
                <li key={item?.id}>
                  <Link
                    state={{ catgoryId: item?.id }}
                    className="footer-link"
                    to={`/produits?categorie=${item?.slug}`}
                  >
                    {item?.nom}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne droite - Liens utiles */}
          <div className="col-lg-4 col-md-6 mb-4 footer-column">
            <h4 className="footer-section-title">Liens utiles</h4>
            <ul className="footer-list">
              <li>
                <NavLink className="footer-link" to="/a-propos-de-nous">
                  Qui sommes nous ?
                </NavLink>
              </li>
              <li>
                <NavLink className="footer-link" to="/politique-de-confidentialite">
                  Politique de confidentialité
                </NavLink>
              </li>
              <li>
                <NavLink className="footer-link" to="/cgu">
                  Conditions générales de vente
                </NavLink>
              </li>
            </ul>
            <div className="footer-social-icons">
              <Link
                className="footer-social-icon"
                to="https://youtube.com/@amilink2?si=aavIaN2e2BCx8SAt"
                target="_blank"
                title="YouTube"
              >
                <FaYoutube />
              </Link>
              <Link
                className="footer-social-icon"
                to="https://www.instagram.com/amilink_business?igsh=MThneGthN280enZyag%3D%3D&utm_source=qr"
                target="_blank"
                title="Instagram"
              >
                <FaInstagram />
              </Link>
              <Link
                className="footer-social-icon"
                to="https://www.tiktok.com/@amilink_?_r=1&_t=ZN-91LBJCVanRu"
                target="_blank"
                title="TikTok"
              >
                <FaTiktok />
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          <div className="footer-separator"></div>
          <p className="footer-copyright-text">
            © {date.getFullYear()}, <span className="footer-copyright-highlight">AMILINK</span>, Commerce électronique propulsé par{" "}
            <Link
              to="https://easymarket.sn"
              target="_blank"
              className="footer-copyright-highlight"
            >
              Easymarket.sn
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FrontFooter;